import React from 'react';
import ReactTable from 'react-table';
import { Button, Spinner } from 'reactstrap';
import {
  columnFilter,
  dateFormatter,
  convertAdditionalData,
  linkFormatter,
} from '../../components/TableComponents/TableComponents';
import { service, numberWithCommas } from '../../helpers';
import { SubmissionsSearchForm } from '../../components/forms/SubmissionSearchForm';

import 'react-table/react-table.css';
import './Submissions.scss';

const DEFAULT_PAGE_SIZE = 25;
const PAGINATION_VALUES = [15, 25, 35, 45];

export default class UserReviews extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      data: {},
      error: false,
      errorMsg: null,
      firstUrl: null,
      nextUrl: null,
      prevUrl: null,
      lastUrl: null,
      count: null,
      pageSize: DEFAULT_PAGE_SIZE,
    };

    this.defaultUrl = `zombie/submission-metadata/?size=${this.state.pageSize}`;
    this.pathName = null;
  }

  getURLParams = (search) => {
    const params = new URLSearchParams(search);
    const [defaultUrl, defaultParamString] = this.defaultUrl.split('?');
    const defaultParams = new URLSearchParams(defaultParamString);

    for (const [paramName, paramValue] of defaultParams.entries()) {
      params.set(paramName, paramValue);
    }

    return [defaultUrl, params];
  };

  componentDidMount = () => {
    const {
      location: { pathname, search },
    } = this.props;

    this.pathName = pathname;
    if (search !== '') {
      const [defaultUrl, params] = this.getURLParams(search);
      this.loadData(`${defaultUrl}?${params.toString()}`);
    } else {
      this.loadData(this.defaultUrl);
    }
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps.location.search !== this.props.location.search) {
      const [defaultUrl, params] = this.getURLParams(
        this.props.location.search,
      );
      this.loadData(`${defaultUrl}?${params.toString()}`);
    }
  };

  search = (values) => {
    const params = new URLSearchParams();

    Object.keys(values).forEach((key) => {
      if (values[key]) {
        params.append(key, values[key]);
      }
    });

    const qs = params.toString();
    const pathName = this.props.location.pathname;
    this.props.history.push(`${pathName}?${qs}`);
  };

  loadData = async (url) => {
    try {
      const response = await service.get(url);
      const next = response.next ? new URL(response.next).search : null;
      const prev = response.previous ? new URL(response.previous).search : null;
      const first = new URLSearchParams(next || prev);
      const last = new URLSearchParams(next || prev);
      first.delete('page');
      last.set('page', 'last');

      this.setState({
        loaded: true,
        data: response.results,
        count: response.count,
        nextUrl: next ? this.pathName + next : null,
        prevUrl: prev ? this.pathName + prev : null,
        firstUrl: `${this.pathName}?${first}`,
        lastUrl: `${this.pathName}?${last}`,
      });
    } catch (e) {
      this.setState({ loaded: true, error: true, errorMsg: e });
    }
  };

  onChangePagination = (pageSize) => {
    this.setState({
      pageSize,
      loaded: false,
    });

    this.defaultUrl = `zombie/submission-metadata/?size=${pageSize}`;
    const [defaultUrl, params] = this.getURLParams(this.props.location.search);
    this.loadData(`${defaultUrl}?${params.toString()}`);
  };

  renderSelectPagination = () => (
    <select
      value={this.state.pageSize}
      onChange={(e) => this.onChangePagination(Number(e.target.value))}>
      {PAGINATION_VALUES.map((pageSize) => (
        <option key={pageSize} value={pageSize}>
          {pageSize}
        </option>
      ))}
    </select>
  );

  renderButton = (label, url, isDisabled) => (
    <Button
      disabled={isDisabled}
      onClick={() => {
        this.setState({ loaded: false });
        this.props.history.push(url);
      }}>
      {label}
    </Button>
  );

  render = () => {
    if (this.state.error) {
      return (
        <div>
          error:{' '}
          {this.state.errorMsg.status
            ? this.state.errorMsg.statusText
            : this.state.errorMsg.message}
        </div>
      );
    }
    const data = {};
    const formVals = new URLSearchParams(this.props.location.search);
    formVals.forEach((value, key) => {
      data[key] = value;
    });

    return (
      <div>
        <div className='reviewsView'>
          <div className='submissionType'>New Submissions</div>
          {<SubmissionsSearchForm handleSubmit={this.search} data={data} />}
          {this.state.loaded ? (
            <ReactTable
              defaultSorted={[{ id: 'createdOn', desc: false }]}
              defaultPageSize={this.state.pageSize}
              showPagination={false}
              pageSize={this.state.pageSize}
              getTrProps={(_, rowInfo) => {
                const score = rowInfo ? parseInt(rowInfo.row.score, 10) : 0;
                const bgColor = score
                  ? score >= 14
                    ? '#ddffdd'
                    : score < 8
                    ? '#ffdddd'
                    : '#ffffdd'
                  : '#ffdddd';
                return {
                  style: {
                    background: bgColor,
                  },
                };
              }}
              data={this.state.data}
              className='-striped -highlight'
              columns={[
                {
                  Header: 'User Phone',
                  width: 150,
                  accessor: 'phoneNumber',
                  Filter: columnFilter,
                },
                {
                  Header: 'Task ID',
                  width: 300,
                  accessor: 'taskId',
                  Filter: columnFilter,
                },
                {
                  Header: 'Score',
                  width: 75,
                  accessor: 'score',
                  Filter: columnFilter,
                },
                {
                  Header: 'Brand',
                  width: 200,
                  accessor: 'brand.name',
                  Filter: columnFilter,
                },
                {
                  Header: 'Retailer',
                  width: 120,
                  accessor: 'store.retailer.name',
                  Filter: columnFilter,
                },
                {
                  Header: 'Country',
                  width: 100,
                  accessor: 'brand.country.name',
                  Filter: columnFilter,
                },
                {
                  Header: 'Date Added',
                  width: 200,
                  accessor: 'createdOn',
                  Cell: (props) => dateFormatter(props),
                  Filter: columnFilter,
                  className: 'tableCenter',
                },
                {
                  Header: 'Soft-Rejected?',
                  width: 200,
                  accessor: 'submission.additionalData',
                  Cell: (props) => convertAdditionalData(props),
                  Filter: columnFilter,
                  className: 'tableCenter',
                },
                {
                  Header: '',
                  width: 60,
                  accessor: 'id',
                  Cell: (props) => linkFormatter(props),
                  filterable: false,
                  className: 'tableCenter',
                },
              ]}
            />
          ) : (
            <div className='loading-spinner-container'>
              <Spinner animation='grow' role='status'>
                <span className='sr-only'>Loading...</span>
              </Spinner>
            </div>
          )}
          <div className='pageButtonDiv'>
            <div className='navigation-botton-container'>
              <div className='itemCount'>
                <p>
                  <span>{'Count '}</span>
                  {this.state.count ? numberWithCommas(this.state.count) : '0'}
                </p>
              </div>
              {this.renderButton(
                'First page',
                this.state.firstUrl,
                !this.state.prevUrl,
              )}
              {this.renderButton(
                'Previous page',
                this.state.prevUrl,
                !this.state.prevUrl,
              )}
              {this.renderButton(
                'Next page',
                this.state.nextUrl,
                !this.state.nextUrl,
              )}
              {this.renderButton(
                'Last page',
                this.state.lastUrl,
                !this.state.nextUrl,
              )}
              {this.renderSelectPagination()}
            </div>
          </div>
        </div>
      </div>
    );
  };
}
